import { useState } from "react";

const navItems = [
  { label: "本期目录", href: "#contents" },
  { label: "解说字幕版", href: "#commentary" },
  { label: "浓缩速看", href: "#condensed" },
  { label: "混剪剪辑", href: "#mashup" },
  { label: "入口下载", href: "#entry" },
  { label: "常见问题", href: "#faq" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="flex items-center justify-between h-16 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
          <span className="w-8 h-8 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-movie-2-line text-base" />
          </span>
          <h1 className="font-heading text-lg md:text-xl font-bold text-foreground-950 whitespace-nowrap">
            黑料视频
          </h1>
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm font-label text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#entry"
            className="hidden md:inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-foreground-950 text-background-50 text-sm font-label whitespace-nowrap hover:bg-foreground-800 transition-colors cursor-pointer"
          >
            <i className="ri-download-2-line" />
            进入入口
          </a>
          <button
            type="button"
            aria-label="展开导航"
            onClick={() => setMenuOpen((value) => !value)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3 flex flex-col">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setMenuOpen(false)}
              className="py-2.5 text-sm font-label text-foreground-700 border-b border-background-100 last:border-0 cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}